/**
 * This is intended to hold many small utils js behavior for ats so to make it re-usable in the code
 *
 * Although you can place your code however you like please use the following naming in this file
 *
 * ats-<your util name or abreviation>-<extra attributes>
 * for example if you create a plugin to refresh image called "image refresh(IR)" the naming would be
 * ats-IR-on-click (for example)
 *
 * current content:
 * 1) CooldDown On Click (cooldown-on-click): This small util will disable a button on click or on form submit
 * - To use it add the following to your button:
 *   - add class cooldown-on-click-button to your button
 *   - add attribute data-cooldown-on-click-text : The text that will show when the button is disabled (by default "In progress..."
 *   - add attribute data-cooldown-on-click-duration : the duration of the button is disabled, you can set it to -1 if you want the button to never re-enable
 * - Or add the following to your form :
 *   - add attribute data-cooldown-on-click-trgButton : is the button to disable when the form is submitted (the button can have the text and duration attributes)
 *   - add class cooldown-on-click-form to your form
 *
 */

$(function () {
    
    /*************** BEGIN cooldown-on-click Events ******************/
    $(document).on('click', '.cooldown-on-click-button', function () {
        cooldownOnClickDisableButton($(this));
    });
    $(document).on('submit', 'form.cooldown-on-click-form', function () {
        let trgtButton = $(this).find($(this).attr('data-cooldown-on-click-target-button'));
        if(trgtButton===undefined)
        {
            trgtButton = $(this).find('button[type="submit"]');
        }
        cooldownOnClickDisableButton(trgtButton);
    });
    /*************** END cooldown-on-click Events ******************/
    /*** Add script to remove white spaces from the start/end of person-forenames & person-surname*/
    $(document).on('focusout', 'input[name="person-forenames"], input[name="person-surname"]', function(){
        let input = $(this);
        input.val(input.val().trimStart().trimEnd());
    });
});


/*************** BEGIN cooldown-on-click Functions ******************/
function cooldownOnClickDisableButton(button) {
    let orgText = $(button).text();
    let replaceText = $(button).attr('data-cooldown-on-click-text');
    let buttonCDD   = $(button).attr('data-cooldown-on-click-duration');
    
    if (!replaceText) {
        replaceText = 'In progress...';
    }
    if (!buttonCDD) {
        buttonCDD = 5000;
    }
    
    $(button).attr('disabled', true);
    $(button).text(replaceText);
    
    if (buttonCDD !== '-1') {
        setTimeout(function () {
            $(button).attr('disabled', false);
            $(button).text(orgText);
        }, buttonCDD);
    }
}
/*************** END cooldown-on-click Functions ******************/
